import { BASE_API_URL } from "utils/constants";
import { get, post } from '../../utils/api';
import { getAccountId, getPlantCode } from "utils/localStorageHelper";
import { DataResponse } from 'services/response';

//Interface của common service
export interface CommonModel {
  key: string | null;
  value: string;
  name?: string;
  data?: boolean | string;
  unit?: string;
  type?: string;
  code?: string;
  options?: any;
  // Company list
  companyId?: string;
}

export interface CommonDateModel {
  fromDate: string;
  toDate: string;
}

export interface BaseModel {
  key?: string;
  label: string;
  value: string | null;
  data?: boolean | string;
  unit?: string;
  type?: string;
  code?: string;
}

//Type của common service
export type CommonDataResponse = {
  data: CommonModel[];
  message: string;
  isSuccess: boolean;
};


export type ProductModel = {
  stt: number,
  sapCode: string,
  productCode: string,
  productId: string,

  phanLoaiVatTuName: string,
  nhomVatTuName: string,
  productName: string,
  actived: boolean
}

// ============ Khai báo phương thức =====================
export interface ICommonServices {
  // =====================COMMON DATE===========================
  // lấy ngày từ common date
  getDateByCommonDate(date: string): Promise<CommonDateModel>;

  // =================================================================
  // Lấy data danh sách công ty
  getListSaleOrg(type?: string): Promise<CommonDataResponse>;
  // Lấy data danh sách common date
  getListSelectCommonDate(type?: string): Promise<CommonDataResponse>;
  // Lấy data danh sách store
  getListSelectCommonStore(accountId: string): Promise<CommonDataResponse>;
  // danh sách dự án
  getListOpportunities(key?: string): Promise<CommonDataResponse>;
  // danh sách nhân viên kinh doanh
  getListPersonInCharge(key?: string): Promise<CommonDataResponse>;

  // GET data common theo key:
  // Dropdown Khu vực : SaleOffice
  getCommonDataByKey(key: string, custom?: string, company?: string): Promise<CommonDataResponse>
  // lấy danh Tỉnh/Thành phố
  getListProvince(area?: string): Promise<CommonDataResponse>
  // lấy danh quận huyện
  getListDistrict(province: string[], key?: string, area?: string): Promise<CommonDataResponse>;
  // lấy danh phường xã
  getListWard(district: string[], key?: string): Promise<CommonDataResponse>
  // lấy danh phường xã theo tỉnh/thành (sau sáp nhập, không còn đi qua quận/huyện)
  getListWardByProvince(province: string[], key?: string): Promise<CommonDataResponse>

  // Lấy danh sách tiêu chí
  getListFilter(key: string): Promise<CommonDataResponse>
  //Danh sách người tạo
  getListCreateBy(key?: string): Promise<CommonDataResponse>
  // Danh sách phòng ban
  getListDepartment(key?: string, companyCode?: string): Promise<CommonDataResponse>
  // Danh sách khách hàng
  getListCustomer(key?: string): Promise<CommonDataResponse>
  // Danh sách khách hàng có id
  getListCustomerHasId(key?: string): Promise<CommonDataResponse>
  // danh sách công ty theo tài khoản
  getCompanyByAccount(): Promise<CommonDataResponse>
  getCompanyByAccountHasId(): Promise<CommonDataResponse>
  // danh sách Chi nhánh theo tài khoản
  getStoreByAccount(): Promise<CommonDataResponse>
  // Danh sách email account
  getListEmail(): Promise<CommonDataResponse>
  // Danh sách nội dung
  getListContents(key?: string): Promise<CommonDataResponse>
  // Danh sách customer segment
  getListCustomerSegment(key?: string): Promise<CommonDataResponse>
  // danh sách khu vực theo quốc gia
  getListAreaByNation(key: any): Promise<CommonDataResponse>
  // danh sách chủ đầu tư
  getListInvestors(key?: string): Promise<CommonDataResponse>
  // danh sách nhóm mua hàng
  getListOrderSeller(key?: string): Promise<CommonDataResponse>
  // Danh sách nhà thiết kế
  getListDesigner(key?: string): Promise<CommonDataResponse>
  // danh sách tổng thầu
  getListContracter(key?: string): Promise<CommonDataResponse>
  // Danh sách đối thủ
  getListCompetitor(key?: string): Promise<CommonDataResponse>
  // xác suất dự án
  getListOpportunitypercent(key?: string): Promise<CommonDataResponse>
  // Năm hoàn thiện
  getListOpportunityyear(): Promise<CommonDataResponse>
  // Tên bảo hành
  getListWarrantyName(): Promise<CommonDataResponse>


  // sản phẩm thị hiếu lấy từ acshopping
  getListSPTH(key?: string): Promise<CommonDataResponse>


  // lấy danh sách chi nhánh theo mã công ty
  getBranchByCompany(company?: string): Promise<CommonDataResponse>

  // danh sách nhóm vật tư
  getListMaterialGroup(data?: object): Promise<CommonDataResponse>
  // danh sách phân loại vật tư
  getListMaterialClass(data?: object): Promise<CommonDataResponse>
  // danh sách sản phẩm
  getListProduct(data?: object): Promise<DataResponse<ProductModel[]>>

  // get domain email
  getDomainEmail(): Promise<CommonDataResponse>
  // get email type
  getEmailType(): Promise<CommonDataResponse>

  // danh sách chương trình
  getListProgram(key?: string): Promise<CommonDataResponse>

  // danh sách phòng ban 2 list role
  getListRole(role?: string, company?: string): Promise<CommonDataResponse>

}
// Hàm khởi tạo các phương nhà của NKMH service
export function createCommonServices(): ICommonServices {
  return {

    // =================COMMON DATE===========================================================================
    // lấy ngày từ common date
    getDateByCommonDate: async (date) => {
      return (
        await get(
          BASE_API_URL,
          `CommonDate/GetDateByCommonDate?CommonDate=${date}`))
        .data;
    },
    // ============================================================================================
    // Hàm lấy data danh sách công ty
    getListSaleOrg: async (type) => {
      return (
        await get(
          BASE_API_URL,
          `Common/select-company`, { type: type }))
        .data;
    },
    // Hàm lấy danh sách common date
    getListSelectCommonDate: async (type) => {
      return (
        await get(
          BASE_API_URL,
          `CommonDate/get-common-date${type ? '?Type=' + type : ''}`))
        .data;
    },
    // Lấy data danh sách store
    getListSelectCommonStore: async (accountId) => {
      return (
        await get(
          BASE_API_URL,
          `Common/select-commonstore${accountId ? `?accountId=${accountId}` : ``}`))
        .data;
    },
    // Danh sách dự án
    getListOpportunities: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Common/opportunities${key ? `?key=${key}` : ''}`))
        .data;
    },
    // Danh sách nhân viên kinh doanh
    getListPersonInCharge: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Common/person-in-charge${key ? `?key=${key}` : ''}`))
        .data;
    },
    // GET data common theo key:
    // Dropdown Khu vực : SaleOffice
    getCommonDataByKey: async (key, custom, company = getPlantCode()) => {
      return (
        await get(
          BASE_API_URL,
          `Common/get-common-data-by-keyword${key ? `/${key}` : ''}${custom ? `?custom=${custom}&` : '?'}${`companyCode=${company}`}`))
        .data;
    },
    // lấy danh Tỉnh/Thành phố
    getListProvince: async (area) => {
      return (
        await get(
          BASE_API_URL,
          `Common/get-list-province${area ? `?area=${area}` : ''}`))
        .data;
    },
    // lấy danh quận huyện
    getListDistrict: async (province, key, area) => {
      const query = [
        key ? `key=${key}` : '',
        area ? `area=${area}` : '',
      ].filter(Boolean).join('&')
      return (
        await post(
          BASE_API_URL,
          `Common/get-list-district${query ? `?${query}` : ''}`, province))
        .data;
    },
    // lấy danh phường xã
    getListWard: async (district, key) => {
      return (
        await post(
          BASE_API_URL,
          `Common/get-list-ward${key ? `?key=${key}` : ''}`, district))
        .data;
    },
    // lấy danh phường xã theo tỉnh/thành (sau sáp nhập, không còn đi qua quận/huyện)
    getListWardByProvince: async (province, key) => {
      return (
        await post(
          BASE_API_URL,
          `Common/get-list-ward-by-province${key ? `?key=${key}` : ''}`, province))
        .data;
    },
    // lấy danh tiêu chí
    getListFilter: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Common/gets-filter/` + key))
        .data;
    },
    //Danh sách người tạo
    getListCreateBy: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Common/createby${key ? `?key=${key}` : ''}`))
        .data;
    },
    //Danh sách phòng ban
    getListDepartment: async (key, companyCode) => {
      return (
        await get(
          BASE_API_URL,
          `Common/department`, {
          key: key,
          CompanyCode: companyCode
        }))
        .data;
    },
    // Danh sách khách hàng
    getListCustomer: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Common/search-customer${key ? `?key=${key}` : ''}`))
        .data;
    },
    // Danh sách khách hàng
    getListCustomerHasId: async (key) => {
      return (
        await get(
          BASE_API_URL,
          `Common/search-customer-get-id${key ? `?key=${key}` : ''}`))
        .data;
    },
    // danh sách công ty theo tài khoản
    getCompanyByAccount: async () => {
      return (await get(BASE_API_URL, `Common/select-companybyaccount?accountId=` + getAccountId())).data;
    },
    // danh sách công ty theo tài khoản có id
    getCompanyByAccountHasId: async () => {
      return (await get(BASE_API_URL, `Common/select-companybyaccountid?accountId=` + getAccountId())).data;
    },



    // danh sách chi nhánh theo tài khoản
    getStoreByAccount: async () => {
      return (await get(BASE_API_URL, `Common/select-store?accountId=` + getAccountId())).data;
    },
    // Danh sách email account
    getListEmail: async () => {
      return (await get(BASE_API_URL, `Common/list-email`)).data;
    },
    // Danh sách nội dung
    getListContents: async (key) => {
      return (await get(BASE_API_URL, `Common/list-content`, { key: key })).data;
    },
    // Danh sách customer segment
    getListCustomerSegment: async (key) => {
      return (await get(BASE_API_URL, `Common/list-cs`, { key: key })).data;
    },
    // danh sách khu vực theo quốc gia
    getListAreaByNation: async (key) => {
      return (await get(BASE_API_URL, `Common/get-common-data-by-nation/` + key)).data;
    },
    // danh sách chủ đầu tư
    getListInvestors: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-investor`, { key: key })).data;
    },
    // danh sách nhóm mua hàng
    getListOrderSeller: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-nhom-hang-sap`, { key: key })).data;
    },
    // Danh sách nhà thiết kế
    getListDesigner: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-designer`, { key: key })).data;
    },
    // danh sách tổng thầu
    getListContracter: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-contractor`, { key: key })).data;
    },
    // Danh sách đối thủ
    getListCompetitor: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-competitor`, { key: key })).data;
    },

    // xác suất dự án
    getListOpportunitypercent: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-opportunitypercent`, { key: key })).data;
    },
    // Năm hoàn thiện
    getListOpportunityyear: async () => {
      return (await get(BASE_API_URL, `Common/get-list-opportunityyear`)).data;
    },
    // Tên bảo hành
    getListWarrantyName: async () => {
      return (await get(BASE_API_URL, `Common/get-list-warranty-name`)).data;
    },

    // sản phẩm thị hiếu lấy từ acshopping
    getListSPTH: async (key) => {
      return (await get(BASE_API_URL, `Common/get-list-spth`, { key: key })).data;
    },


    // lấy danh sách chi nhánh theo mã công ty
    getBranchByCompany: async (company) => {
      return (await get(BASE_API_URL, `Common/select-saleorg-by-company`, { company: company })).data;
    },


    // =================================================================
    getListMaterialGroup: async (data) => {
      return (await post(BASE_API_URL, `Common/get-list-nhom-vat-tu`, data)).data;
    },

    getListMaterialClass: async (data) => {
      return (await post(BASE_API_URL, `Common/get-list-phan-loai-vat-tu`, data)).data;
    },

    getListProduct: async (data) => {
      return (await post(BASE_API_URL, `Common/get-list-san-pham`, data)).data;
    },

    // get domain email
    getDomainEmail: async () => {
      return (await get(BASE_API_URL, `Common/select-domain`)).data;
    },
    // get email type
    getEmailType: async () => {
      return (await get(BASE_API_URL, `Common/select-email-type`)).data;
    },
    // get list program
    getListProgram: async (key) => {
      return (await get(BASE_API_URL, `Common/list-program`, {
        KeyWord: key
      })).data;
    },
    // danh sách phòng ban roles
    getListRole: async (role, company) => {
      return (await get(BASE_API_URL, `Common/list-role`, {
        company: company,
        role: role
      })).data;
    }
  };
}
